export const en = {
	'Международная цифровая платформа для хранения и оптовой торговли рыбой и морепродуктами':
		'International digital platform for organized wholesale and storage of fish products',

	'Повышаем эффективность, помогаем масштабировать и устойчиво развивать бизнес участников оптовой торговли и логистики рыбной продукции через объединение на нашей удобной площадке':
		'We improve effectiveness, assist in scaling and sustainably develop the businesses of wholesalers and logistics of fish produce via unification on our convenient platform',

	Перейти: 'Visit',
};
